module.exports = __webpack_public_path__ + "static/media/not-found.8677fbe5.svg";